var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "stay-overview-card" }, [
    _c("div", { staticClass: "stay-image" }, [
      _c(
        "picture",
        {
          directives: [
            {
              name: "lazyload",
              rawName: "v-lazyload",
              value: {
                src: _vm.stay.sitecoreContent.room.image,
                variant: "room-overview",
              },
              expression:
                "{\n        src: stay.sitecoreContent.room.image,\n        variant: 'room-overview'\n      }",
            },
          ],
          staticClass: "image-wrapper",
        },
        [
          _c("img", {
            staticClass: "image",
            attrs: {
              src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
              alt: _vm.stay.sitecoreContent.room.title,
            },
          }),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "stay-description" }, [
      _c("div", { staticClass: "stay-description-line box" }, [
        _c("div", { staticClass: "section-label" }, [
          _vm._v(
            _vm._s(_vm.tc("noums.roomSingular")) + " " + _vm._s(_vm.index)
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "overview-item guests" }, [
          _c("div", { staticClass: "item-label bold-item" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.stay.sitecoreContent.room.title) +
                " | " +
                _vm._s(_vm.stay.sitecoreContent.bed.title) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "item-value section-label",
            domProps: { innerHTML: _vm._s(_vm.stayGuestsSummary) },
          }),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "edit",
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.editStay($event)
              },
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar",
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.editStay($event)
              },
            },
          },
          [_vm._v(_vm._s(_vm.tc("booking.edit")))]
        ),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "section-label" }, [
          _vm._v(_vm._s(_vm.tc("noums.rateSingular"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "overview-item" }, [
          _c("div", { staticClass: "item-label bold-item" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.stay.sitecoreContent.rate.title) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-value" }, [
            _c("div", [_vm._v(_vm._s(_vm.avgPerNight))]),
            _vm._v(" "),
            _c("div", { staticClass: "section-label capitalize" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.tc("booking.avgPerNight")) +
                  "\n          "
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }